module.exports = __webpack_public_path__ + "img/employee-branches.eef37244.svg";